interface Config {
  roleMode: string
}

// eslint-disable-next-line import/no-mutable-exports
let config:Config = {
  roleMode: 'service',
};

interface ConfigOverride {
  roleMode?: string
}

export function configure(c: ConfigOverride) {
  config = Object.assign(config, c);
}

export function isServiceRoleMode(): boolean {
  return (config.roleMode === 'service');
}

export default config;
